"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocateDealerResult = exports.LocateDealerPayload = exports.LocationList = exports.Location = exports.DeleteLocationPayload = exports.UpdateLocationPayload = exports.CreateLocationPayload = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const field_1 = require("../../../openapi/field");
const dealer_1 = require("../../shared/dealer");
Object.defineProperty(exports, "Location", { enumerable: true, get: function () { return dealer_1.Location; } });
exports.NAMESPACE = 'Culligan.Api.V1.Admin.Dealer.Schema';
exports.CreateLocationPayload = effect_1.Schema.Struct({
    code: (0, field_1.nonEmpty)('Dealer code'),
    name: (0, field_1.nonEmpty)('Dealer or dealership name'),
    country: (0, field_1.nonEmpty)('Country. Also the Cosmos partition key for dealer_locations.'),
    address: (0, field_1.optionalString)('Street address'),
    city: (0, field_1.optionalString)('City'),
    zip: (0, field_1.optionalString)('ZIP / postal code'),
    state: (0, field_1.optionalString)('State, province, or region'),
    phone: (0, field_1.optionalString)('Phone number'),
    email: (0, field_1.optionalEmail)('Contact email'),
    website: (0, field_1.optionalString)('Website URL. Runtime checks isString only, not a URL format.'),
    contactPersonName: (0, field_1.optionalString)('Name of the owner or contact person'),
}).annotations({
    identifier: `${exports.NAMESPACE}.CreateLocationPayload`,
    description: 'Request body to create a dealer location',
});
exports.UpdateLocationPayload = effect_1.Schema.Struct({
    id: (0, field_1.nonEmpty)('Dealer location id'),
    ...exports.CreateLocationPayload.fields,
}).annotations({
    identifier: `${exports.NAMESPACE}.UpdateLocationPayload`,
    description: 'Request body to overwrite a dealer location',
});
exports.DeleteLocationPayload = effect_1.Schema.Struct({
    id: (0, field_1.nonEmpty)('Dealer location id'),
}).annotations({
    identifier: `${exports.NAMESPACE}.DeleteLocationPayload`,
    description: 'Request body to delete a dealer location',
});
exports.LocationList = effect_1.Schema.Struct({
    items: effect_1.Schema.propertySignature(effect_1.Schema.Array(dealer_1.Location)).annotations({
        description: 'Dealer locations. Admins see every row; a user with the Dealer role only sees ids in dealerIds.',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.LocationList`,
    description: 'List of dealer locations',
});
exports.LocateDealerPayload = effect_1.Schema.Struct({
    address: (0, field_1.optionalString)('Street address (SOAP Address2)'),
    city: (0, field_1.optionalString)('City'),
    state: (0, field_1.optionalString)('State / province'),
    zip: (0, field_1.optionalString)('Postal code'),
    country: (0, field_1.optionalString)('Country. SOAP defaults to "United States" when omitted or empty.'),
}).annotations({
    identifier: `${exports.NAMESPACE}.LocateDealerPayload`,
    description: 'Installation address to look up a serving dealer via CPort SOAP',
});
exports.LocateDealerResult = effect_1.Schema.Struct({
    dealerNumber: (0, field_1.nullableString)('CPort dealer number, or null if none'),
    sapCustomerNumber: (0, field_1.nullableString)('SAP customer number, or null if none'),
    dealerTitle: (0, field_1.nullableString)('Dealer title, or null if none'),
    dealerCity: (0, field_1.nullableString)('Dealer city, or null if none'),
    dealerState: (0, field_1.nullableString)('Dealer state, or null if none'),
    rcCode: (0, field_1.nullableString)('CPort GEOStatus RC code'),
}).annotations({
    identifier: `${exports.NAMESPACE}.LocateDealerResult`,
    description: 'First non-nil Dealer block from the CPort LocateDealer SOAP response',
});
//# sourceMappingURL=schema.js.map